import { INVOICES } from '../types';

export default {
  state: {
    invoicesQuery: null,
    invoicesInfiniteQuery: null,
    invoicepositionQuery: null,
  },
  getters: {},
  mutations: {
    [INVOICES.SET_INVOICES_QUERY](state, payload) {
      state.invoicesQuery = payload;
    },
    [INVOICES.SET_INVOICES_INFINITE_QUERY](state, payload) {
      state.invoicesInfiniteQuery = payload;
    },
    [INVOICES.SET_INVOICES_POSITIONS_QUERY](state, payload) {
      state.invoicepositionQuery = payload;
    },
  },
  actions: {},
};
